import I18n from './i18n'

export const AmuiI18n = I18n

export default Vue => Vue.component(I18n.name, I18n)
